"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M11.0002 2h2v4h-2V2zm7.364 2.2218 1.4142 1.4142L16.95 8.4645l-1.4142-1.4142 2.8284-2.8285zm3.635 6.7787v2h-4v-2h4zm-2.2215 7.3628-1.4142 1.4142-2.8284-2.8284 1.4142-1.4143 2.8284 2.8285zm-6.7782 3.6353h-2v-4h2v4zm-7.3642-2.2204L4.221 18.364l2.8284-2.8285 1.4142 1.4142-2.8284 2.8285zM1.999 12.9989v-2h4v2h-4zm2.2218-7.3622L5.635 4.2225 8.4634 7.051 7.0492 8.4652 4.2208 5.6367z"
  })];
};

exports.default = _default;